import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Product } from 'product-shared';
import { Promotion } from 'promotion-shared';
import { ProductCardChipsComponent, ProductCardPriceComponent } from 'sakura-ui';

@Component({
  selector: 'lib-product-box-pricing',
  templateUrl: './product-box-pricing.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProductCardChipsComponent, ProductCardPriceComponent],
})
export class ProductBoxPricingComponent {
  public product = input.required<Product>();
  public promotion = input<Promotion>(null);
  public lightMode = input(false);
  public isNavProduct = input(false);
  public discountedPrice = input.required<number>();
  public discountPercentage = input.required<number>();
  public chipLabels = input<string[]>([]);
  public hasPromotion = computed(() => !!this.promotion());
  public hasDiscountedCost = computed(
    () => this.product()?.discountedPrice(this.promotion()?.discountAmount) < this.product()?.monthly_cost
  );
}
